export const GET_SIGNABLE_DOCUMENTS = 'signable-documents/GET_SIGNABLE_DOCUMENTS'
export const EDIT_SIGNABLE_DOCUMENT = 'signable-documents/EDIT_SIGNABLE_DOCUMENT'
export const REMOVE_SIGNABLE_DOCUMENTS_FOR_CONTRACT = 'signable-documents/REMOVE_SIGNABLE_DOCUMENTS_FOR_CONTRACT'
export const GET_FM_METADATAS = 'signable-documents/GET_FM_METADATAS'
export const ADD_LOCKED_FM_METADATA = 'signable-documents/ADD_LOCKED_FM_METADATA'
export const REMOVE_LOCKED_FM_METADATA = 'signable-documents/REMOVE_LOCKED_FM_METADATA'
export const SET_FM_METADATA = 'signable-documents/SET_FM_METADATA'
export const SET_FM_METADATA_LOADING = 'signable-documents/SET_FM_METADATA_LOADING'
export const SET_FM_METADATA_ERROR = 'signable-documents/SET_FM_METADATA_ERROR'
export const SET_SIGNABLE_DOCUMENTS_GENERATING = 'signable-documents/SET_SIGNABLE_DOCUMENTS_GENERATING'
export const DOCUMENTS_REGENERATED = 'signable-documents/DOCUMENTS_REGENERATED'
